import styled, { css } from 'styled-components';
import { ScrollType } from '../modal.types';
import { ModalContentProps } from './modalContent.types';

const handlePosition = ({ position }: ModalContentProps) => {
  if (!position) {
    return css`
      position: relative;
    `;
  } else {
    const positionString = Object.keys(position).reduce(
      (accumulatedPositions, positionKey) =>
        `${accumulatedPositions} ${positionKey}: ${position[positionKey as keyof typeof position]};`,
      '',
    );

    return css`
      position: fixed;
      ${positionString}
    `;
  }
};

export const ModalContentContainer = styled.div.attrs<ModalContentProps>({ tabIndex: 0 })`
  &:focus {
    outline: none;
  }

  ${handlePosition};

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `};
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `};

  /**
   * Scenarios to add margin-top to accommodate the close button so it is not hidden off screen
   * 1. When ScrollType.CONTAINER is used
   * 2. When isCentered is false
   * Note: These will never apply when close button is hidden
   */
  ${({ hideCloseButton, isCentered, scrollType }) =>
    !hideCloseButton && (!isCentered || scrollType === ScrollType.CONTAINER) && 'margin-top: 54px;'}

  ${({ hideCloseButton, isCentered, scrollType }) => {
    /**
     * The content will be contained within the viewport and overflowed content will be scrollable within.
     * - A separate container ModalContentScrollContainer will be injected so thee close button is not hidden
     * - The scrollbar will be on the right edge of the content
     * - Scrolling with the cursor over the backdrop will not cause the content to scroll
     */
    if (scrollType === ScrollType.CONTENT) {
      // If isCentered is true, offset must be doubled to account for space on top and bottom
      const closeButtonOffset = isCentered ? '108px' : '54px';
      // No offset if close button is hidden
      const maxHeight = hideCloseButton ? '100%' : `calc(100% - ${closeButtonOffset})`;
      return css`
        display: flex;
        flex-direction: column;
        max-height: ${maxHeight};
      `;
    }

    return;
  }}
`;

export const ModalContentScrollContainer = styled.div`
  overflow: auto;
  overscroll-behavior: contain;
`;
